import React from "react";
import { Icon } from "../components";

interface CloseButtonProps {
  onPress?: () => void;
  testID?: string;
}

export function CloseButton(props: CloseButtonProps) {
  const { onPress = () => {} } = props;

  return (
    <button className="reset-button close-button" onClick={onPress}>
      <Icon name="x" />
    </button>
  );
}
